import { render, staticRenderFns } from "./WsUpdate.vue?vue&type=template&id=53cd093b&"
import script from "./WsUpdate.vue?vue&type=script&lang=js&"
export * from "./WsUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports